import styled from 'styled-components';
import { InputNumber as InputNumero } from 'antd';

export const InputNumber = styled(InputNumero)`
  && .ant-input-number-handler-wrap {
    display: none;
  }
`;
